import styled, { css } from 'styled-components';
import theme from '@styles/theme';

export const TableBody = styled.div<{ $maxWidth?: number; $minHeight?: number; $height?: number; $margin?: string; }>`
  max-width: ${({ $maxWidth }) => $maxWidth ? $maxWidth : 1118}px;
  min-height: ${({ $minHeight }) => $minHeight ? $minHeight : 540}px;
  margin: ${({ $margin }) => $margin ? $margin : 0};

  ${({ $height }) => $height && css`
    height: ${$height}px;
    overflow-y: scroll;
  `};
`;
export const TableRow = styled.div<{
	$isFixed?: boolean;
	$disabled?: boolean;
	$default?: boolean;
}>`
  height: 52px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${theme.colors.ultraLightGrayBorder};
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.lightGrayHoverColor};
  }

  // 비활성화
  ${({ $disabled }) => $disabled && css`
    cursor: initial;

    &:hover {
      background-color: inherit;
    }

    & * {
      color: ${theme.colors.lightGrayFontColor} !important;
    }
  `}
  
  // 기본 커서
  ${({ $default }) => $default && css`
    cursor: initial;

    &:hover {
      background-color: ${theme.colors.whiteColor};
    }
  `}

  // 상단 고정
  ${({ $isFixed }) => $isFixed && css`
    cursor: initial;
  	background-color: ${theme.colors.ultraLightGrayBorder};
  `}
`;
export const TableCell = styled.div<{ $minWidth: number; $width: number; $checkbox?: boolean }>`
  min-width: ${({ $minWidth }) => $minWidth}px;
  width: ${({ $width }) => $width}%;
  height: 100%;
  display: flex;
  align-items: center;
  font-family: PretendardRegular, AppleSDGothicNeoRegular, sans-serif;
  position: relative;

  &:first-child {
    padding-left: 20px;
  }

  &[data-tooltip]:hover::after {
    content: attr(data-tooltip);
    font-size: 12px;
    color: ${theme.colors.whiteColor};
    white-space: nowrap;
    position: absolute;
    padding: 6px 10px;
    top: 0%;
    left: 50%;
    z-index: 100;
    transform: translateX(-50%);
    border-radius: 4px;
    background-color: ${theme.colors.darkGrayBgColor};
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  }

  ${({ $checkbox }) => $checkbox && css`
    height: 100%;
    display: flex;
    align-items: center;
  `};


`;
export const TableText = styled.div<{ $link?: boolean; $fontColor?: string }>`
  width: 94%;
  color: ${({ $fontColor }) => ($fontColor ? $fontColor : theme.colors.blackColor)};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 2px 0;

  ${({ $link }) => $link && css`
    &:hover {
      color: ${theme.colors.activeSkyBlue};
    }
  `};
`;
export const EmptyBox = styled.div<{ $height?: number; $padding?: string }>`
  height: ${({ $height }) => ($height ? $height : 100)}px;
  padding: ${({ $padding }) => ($padding ? $padding : '0 20px')};
  display: flex;
  align-items: center;
`;
export const TableButton = styled.button`
  min-width: 50px;
  height: 32px;
  font-size: 15px;
  font-family: AppleSDGothicNeoRegular, sans-serif;
  white-space: nowrap;
  padding: 6px 12px;
  border-radius: 4px;
  background-color: ${theme.colors.lightGrayHoverColor};

  &:hover {
    background-color: ${theme.colors.lightGrayFontColor};
  }

  & + & {
    margin-left: 12px;
  }

  &:disabled {
    background-color: ${theme.colors.lightGrayHoverColor};
  }
`;
export const OrderImage = styled.img<{ $disabled?: boolean }>`
  cursor: move !important;

  ${({ $disabled }) => $disabled && css`
    cursor: initial;
  `};
`;
export const TableImage = styled.img<{ $width?: number; $height?: number }>`
  width: ${({ $width }) => ($width ? $width : 32)}px;
  height: ${({ $height }) => ($height ? $height : 32)}px;
  border-radius: 4px;
  object-fit: cover;
`;
